import { createApp, configureCompat } from 'vue'
import router from './router'
import store from './store'



import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css'

import SvgIcon from './components/SvgIcon/index.vue'

import App from './App.vue'

configureCompat({
    RENDER_FUNCTION: false,
    COMPONENT_V_MODEL: false,
    ATTR_FALSE_VALUE: false,
    COMPONENT_ASYNC: false,
    ATTR_ENUMERATED_COERCION: 'suppress-warning',
    TRANSITION_GROUP_ROOT: false,
    INSTANCE_ATTRS_CLASS_STYLE: false,
    WATCH_ARRAY: false
});

const app = createApp(App)
app.component('svg-icon', SvgIcon)
app.use(ElementPlus)
app.use(router)
app.use(store)
Date.prototype.format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1,                 //月份 
        "d+": this.getDate(),                    //日 
        "h+": this.getHours(),                   //小时 
        "m+": this.getMinutes(),                 //分 
        "s+": this.getSeconds(),                 //秒 
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
        "S": this.getMilliseconds()             //毫秒 
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
    }
    return fmt;
}

// 在应用挂载前，从 sessionStorage 恢复用户信息
store.dispatch('user/RestoreUserInfo')

app.mount('#app')